  const initState = {
    memberBodyMeasurements: [],
    memberBodyMeasurementsCount: 0,
    addBodyMeasurementsModal: false,
  };
  
  const bodyMeasurementsReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_MEMBER_BODY_MEASUREMENTS":
        return {
          ...state,
          memberBodyMeasurements: action.payload.data,
        };
      case "SET_MEMBER_BODY_MEASUREMENTS_COUNT":
        return {
          ...state,
          memberBodyMeasurementsCount: action.payload.data,
        };
      case "ADD_BODY_MEASUREMENTS_MODAL":
        return {
          ...state,
          addBodyMeasurementsModal: action.payload.data,
        };
      default:
        return { ...state };
    }
  };
  
  export default bodyMeasurementsReducer;
  